import { browser } from '$app/env';
import type { CachedSearchResult } from '#lib/models/cachedSearch.ts';
import type { ActiveJournalEntry, JournalSearchState } from '#lib/models/journal.ts';
import { wrap } from 'comlink';

/**
 * Don't use top level await as it is not supported in Safari yet (as of March 2026).
 * https://caniuse.com/wf-top-level-await
 */
const worker: any = browser
  ? import('./worker?worker').then((w) => wrap(new w.default()))
  : undefined;

export async function sortOrSearch(
  entries: Array<ActiveJournalEntry>,
  search: JournalSearchState,
): Promise<CachedSearchResult<ActiveJournalEntry>> {
  if (browser) {
    return (await worker).sortOrSearch(entries, search);
  } else {
    return { data: [], totalEntries: 0 };
  }
}

export async function loadPage(index: number, count: number): Promise<Array<ActiveJournalEntry>> {
  if (browser) {
    return (await worker).loadPage(index, count);
  } else {
    return [];
  }
}
